/* eslint-disable linebreak-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import Fade from 'react-awesome-reveal';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function Advantage({ data }) {
  const { t } = useLanguage();

  return (
    <div className="py-20 mb-24 sm:mb-18 xl:mb-16 border-t border-gray-200 pb-6" style={{ backgroundColor: "rgba(249,250,251,0.8)" }}>
      <div className="container mx-auto">
        <Fade bottom triggerOnce>
          <h1 className="text-5xl text-theme-blue text-center font-bold">{t('advantagesTitle')}</h1>

          <p className="font-bold text-lg text-green-900 text-center mb-12 sm:mb-5 xl:mb-0">
            {t('advantagesSubtitle')}
          </p>
        </Fade>

        <div className="flex flex-col sm:flex-row">
          <div className="flex-col">
            {
              data[0].map((item, index) => {
                // Get translation keys for first column
                let titleKey = '';
                let descKey = '';
                if (index === 0) {
                  titleKey = 'advantage1Title';
                  descKey = 'advantage1Desc';
                } else if (index === 1) {
                  titleKey = 'advantage2Title';
                  descKey = 'advantage2Desc';
                }
                
                return (
                  <Fade bottom triggerOnce delay={500 * index} key={index}>
                    <div>
                      <div className="bg-white flex flex-row items-center p-3 my-6 mx-3 sm:my-7 sm:mx-3 xl:my-14 xl:mx-7 rounded-2xl shadow-xl border border-light-theme-purple transform transition duration-500 hover:scale-105">
                        <img src={item.imageUrl} alt="" className="w-1/3" />
                        <div className="flex-col pl-5">
                          <h2 className="text-theme-blue text-2xl">{t(titleKey)}</h2>
                          <p className="font-bold text-green-900">{t(descKey)}</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                );
              })
            }
          </div>
          <div className="flex-col -mt-4 sm:mt-14">
            {
              data[1].map((item, index) => {
                // Get translation keys for second column
                let titleKey = '';
                let descKey = '';
                if (index === 0) {
                  titleKey = 'advantage3Title';
                  descKey = 'advantage3Desc';
                } else if (index === 1) {
                  titleKey = 'advantage4Title';
                  descKey = 'advantage4Desc';
                }
                
                return (
                  <Fade bottom triggerOnce delay={500 * index} key={index}>
                    <div>
                      <div className="bg-white flex flex-row items-center p-3 my-6 mx-3 sm:my-7 sm:mx-3 xl:my-14 xl:mx-7 rounded-2xl shadow-xl border border-light-theme-purple transform transition duration-500 hover:scale-105">
                        <img src={item.imageUrl} alt="" className="w-1/3" />
                        <div className="flex-col pl-5">
                          <h2 className="text-theme-blue text-2xl">{t(titleKey)}</h2>
                          <p className="font-bold text-green-900">{t(descKey)}</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                );
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
}
